module.exports = __webpack_public_path__ + "img/gift-theOne-top.f6cd78b8.png";